"use client";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

export type Mode = "light" | "dark";

type State = {
  rootFontSize: number;
  formGap: number;
  mode: Mode;
  contained: boolean;
};

const initialState: State = {
  rootFontSize: 16,
  formGap: 4,
  mode: "light",
  contained: false,
};

export const preferencesSlice = createSlice({
  name: "favourites",
  initialState,
  reducers: {
    setRootFontSize: (state, action: PayloadAction<number>) => {
      state.rootFontSize = action.payload;
    },
    setMode: (state, action: PayloadAction<Mode>) => {
      state.mode = action.payload;
    },
    setContained: (state, action: PayloadAction<boolean>) => {
      state.contained = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
  },
});

export const { setRootFontSize, setMode, setContained } =
  preferencesSlice.actions;
export default preferencesSlice.reducer;
